import { render, staticRenderFns } from "./Entity.vue?vue&type=template&id=2cba88e7&scoped=true&"
import script from "./Entity.vue?vue&type=script&lang=js&"
export * from "./Entity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cba88e7",
  null
  
)

export default component.exports